// extracted by mini-css-extract-plugin
export var Logo = "styles-module--Logo--16QNk";